export const Validations = {
  securePassword: {
    rule: /^.{8,}$/,
    message: 'Password requires at least 8 characters'
  }
};

export const subscriptionMessage: string = 'This feature is disabled due to subscription level.';
